<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="naviPath ==='centers' && !isLoading" class="flex flex-row pt-0 mb-4 mr-5 ml-0 gap-5 cursor-pointer">
    <p class="font-semibold text-sm text-[#424242] dark:text-white" (click)="navigateToCenters()">Centres</p>
    <p class="font-semibold text-sm text-[#424242] dark:text-white" (click)="navigateToCenterDashboard()">Centre
        Dashboard</p>
    <p class="font-semibold text-sm text-[#424242] dark:text-white" onclick="history.back()">Centre Officers</p>
    <p class="font-semibold text-sm text-[#424242] dark:text-white">Edit Officer</p>
</div>

<div *ngIf="naviPath ==='manage-officers' && !isLoading"
    class="flex gap-5 font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">
    <p onclick="history.back()">Manage Officers</p>
    <p>Edit Officer</p>
</div>

<div *ngIf="naviPath ==='distribution-officers' && !isLoading"
    class="flex gap-5 font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">
    <p onclick="history.back()">Manage Officers</p>
    <p>Edit Officer</p>
</div>

<div *ngIf="naviPath ==='distribution-center'"
    class="flex gap-5 font-semibold text[#424242] mb-4 mr-5 ml-0 dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">
    <p onclick="history.back()">Distribution Centres</p>
    <p onclick="history.back()">Center Dashboard</p>
    <p>Edit Officer</p>
</div>

<div #scrollTarget *ngIf="!isLoading" class="mx-auto p-6 bg-white dark:bg-[#363636] rounded-lg shadow-mg">
    <form #PageOneForm="ngForm" (ngSubmit)="onSubmitFormPage1(PageOneForm)">
        <div *ngIf="selectedPage === 'pageOne'">
            <h2 class="text-xl mb-6 text-[#292929] dark:text-textDark font-semibold">Edit Personal Details</h2>
            <div>
                <div class="flex justify-center pt-3 pb-9">
                    <div class="relative">
                        <input type="file" id="imageUpload" accept="image/*" class="hidden"
                            (change)="onFileSelected($event)" />

                        <!-- Default user icon - shows when no image exists -->
                        <div *ngIf="(!personalData.image && !selectedImage) || imageLoadError"
                            (click)="triggerFileInput($event)"
                            class="flex rounded-full border-solid border-2 justify-center items-center w-40 h-40 bg-gray-100">
                            <i class="fa-regular fa-user text-6xl"></i>
                        </div>

                        <!-- Existing profile image - shows only when no new image is selected -->
                        <img *ngIf="personalData.image && !selectedImage && !imageLoadError"
                            class="rounded-full w-40 h-40 object-cover" (click)="triggerFileInput($event)"
                            [src]="personalData.image" alt="Profile Picture" (error)="handleImageError()" />

                        <!-- Newly selected image - shows only when selected -->
                        <img *ngIf="selectedImage" class="rounded-full w-40 h-40 object-cover" [src]="selectedImage"
                            (click)="triggerFileInput($event)" alt="Profile Picture" (error)="handleImageError()" />

                        <span (click)="triggerFileInput($event)"
                            class="absolute bottom-5 right-5 transform translate-x-1/4 translate-y-1/4 px-3 py-2 bg-[#3980C0] rounded-full cursor-pointer">
                            <i class="fa-solid fa-pen text-xl text-white"></i>
                        </span>
                    </div>
                </div>

                <div *ngIf="personalData.status === 'Approved' " class="w-40 mb-4" (click)="openPopup(personalData)">
                    <button
                        class="w-full text-normal font-bold bg-[#FF0000] hover:bg-red-700 py-3 px-1 text-white rounded-xl shadow-lg">
                        Reset Password
                    </button>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 mb-4">
                    <div *ngIf="logingRole === 'Distribution Centre Head'">
                        <label for="centerId" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Distribution Centre Name *
                        </label>

                        <div class="relative w-full">
                            <!-- Input acting as dropdown -->
                            <div class="relative">
                                <input type="text" id="centerId" name="centerId" [(ngModel)]="selectedCenterName"
                                    #centerIdInput="ngModel" required placeholder="-- Select a centre --" readonly
                                    (click)="toggleDropdown()"
                                    class="form-control focus:outline-none focus:ring-0 focus:border-gray-300 mt-1 block w-full p-2 pr-10 border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] dark:text-textDark cursor-pointer" />

                                <!-- Arrow icon -->
                                <i *ngIf="!centreDropdownOpen"
                                    class="fa-solid fa-angle-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>

                                <i *ngIf="centreDropdownOpen"
                                    class="fa-solid fa-angle-up absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                            </div>

                            <!-- Dropdown panel -->
                            <div *ngIf="centreDropdownOpen"
                                class="absolute z-50 mt-1 w-full bg-white border dark:bg-[#292929] dark:text-textDark border-gray-200 dark:border-[#828282] rounded-md max-h-60 overflow-y-auto shadow-lg">

                                <!-- Sticky search input -->
                                <div class="sticky top-0 bg-gray-100 dark:bg-[#292929] z-20">
                                    <div class="relative">
                                        <input type="text" placeholder="Search..." (input)="onSearchInput($event)"
                                            class="dropdown-search-input form-control dark:text-textDark dark:bg-[#292929] w-full p-2 pr-10 border-b border-gray-300 rounded-t-md" />
                                        <i
                                            class="fa-solid fa-magnifying-glass absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"></i>
                                    </div>
                                </div>

                                <!-- List with selected highlight (light blue background like the image) -->
                                <div *ngFor="let item of filteredCenterArr"
                                    class="flex items-center p-2 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
                                    (click)="selectCenter(item)">
                                    <span [ngClass]="{
          'text-blue-600 dark:text-blue-400 font-medium': item.id === personalData.centerId,
          'text-gray-900 dark:text-textDark': item.id !== personalData.centerId
        }">

                                        {{ item.regCode }} - {{ item.centerName }}

                                    </span>
                                    <span *ngIf="isSelected(item)" class="ml-2 text-blue-600">✓</span>
                                </div>
                                <div *ngIf="filteredCenterArr.length === 0"
                                    class="p-2 text-gray-500 dark:text-gray-400 bg-white dark:bg-[#1D1D1F] text-sm text-center">
                                    No options found
                                </div>
                            </div>
                        </div>
                        <div *ngIf="centerIdInput.touched && !personalData.centerId && logingRole === 'Distribution Centre Head'"
                            class="text-red-500 text-sm mt-1">
                            <div>Distribution Centre Name is required</div>
                        </div>
                    </div>

                    <div class="relative" (clickOutside)="isJobRoleOpen = false">
                        <label for="jobRole" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Job Role *
                        </label>

                        <div class="relative w-full">
                            <div class="relative">
                                <input type="text" id="jobRole" [value]="personalData.jobRole"
                                    placeholder="-- Select a job role --" readonly (click)="toggleJobRoleDropdown()"
                                    class="form-control focus:outline-none focus:ring-0 focus:border-gray-300 mt-1 block w-full p-2 pr-10 border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] dark:text-textDark cursor-pointer" />
                                <i *ngIf="!isJobRoleOpen"
                                    class="fa-solid fa-angle-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                                <i *ngIf="isJobRoleOpen"
                                    class="fa-solid fa-angle-up absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                            </div>

                            <div *ngIf="isJobRoleOpen"
                                class="absolute z-50 mt-1 w-full bg-white border dark:bg-[#292929] dark:text-textDark border-gray-200 dark:border-[#828282] rounded-md shadow-lg max-h-60 overflow-y-auto">
                                <div *ngFor="let role of jobRoles" (click)="getJobRole(role)"
                                    class="flex items-center p-2 dark:text-textDark bg-white cursor-pointer dark:bg-[#292929] hover:bg-gray-200 dark:hover:bg-gray-700">
                                    <span [ngClass]="{
      'text-blue-600 dark:text-blue-400 font-medium': role === personalData.jobRole,
      'text-gray-900 dark:text-textDark': role !== personalData.jobRole
    }">
                                        {{ role }}
                                    </span>
                                    <span *ngIf="role === personalData.jobRole" class="ml-2 text-blue-600">✓</span>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="jobRoleInputTouched && !personalData.jobRole" class="text-red-500 text-sm mt-1">
                            Job Role is required
                        </div>
                    </div>

                    <div *ngIf="isDriverRole(personalData.jobRole)">
                        <label for="drvCategory" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                            Driver Category *
                        </label>

                        <app-searchable-dropdown id="drvCategory" name="drvCategory"
                            [items]="driverCategoryDropdownItems" [placeholder]="'Select a category'"
                            [searchPlaceholder]="'Search categories...'" [(ngModel)]="personalData.drvCategory"
                            #drvCategoryInput="ngModel" (ngModelChange)="onDriverCategorySelectionChange($event)"
                            borderClass="border border-gray-300"
                            placeholderClass="text-gray-400"></app-searchable-dropdown>

                        <!-- validation message (same logic you already use) -->
                        <div *ngIf="drvCategoryInput.touched && !personalData.drvCategory"
                            class="text-red-500 text-sm mt-1">
                            <div>Driver Category is required</div>
                        </div>
                    </div>

                    <div
                        *ngIf="(logingRole === 'Distribution Centre Head' && (personalData.jobRole === 'Distribution Officer')) || (logingRole === 'Distribution Centre Head' && isDriverRole(personalData.jobRole))">
                        <label for="irmId" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Manager *
                        </label>

                        <div class="relative w-full">
                            <!-- Input acting as dropdown -->
                            <div class="relative">
                                <input type="text" id="irmId" name="irmId" [(ngModel)]="selectedManager"
                                    #irmIdInput="ngModel" required placeholder="-- Select a manager --" readonly
                                    (click)="toggleManagerDropdown()"
                                    class="form-control focus:outline-none focus:ring-0 focus:border-gray-300 mt-1 block w-full p-2 pr-10 border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] dark:text-textDark cursor-pointer" />

                                <!-- Arrow icon -->
                                <i *ngIf="!managerDropdownOpen"
                                    class="fa-solid fa-angle-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>

                                <i *ngIf="managerDropdownOpen"
                                    class="fa-solid fa-angle-up absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                            </div>

                            <!-- Dropdown panel -->
                            <div *ngIf="managerDropdownOpen"
                                class="absolute z-50 mt-1 w-full bg-white border dark:bg-[#292929] dark:text-textDark border-gray-200 dark:border-[#828282] rounded-md max-h-60 overflow-y-auto shadow-lg">

                                <!-- Sticky search input -->
                                <div class="sticky top-0 bg-gray-100 dark:bg-[#292929] z-20">
                                    <div class="relative">
                                        <input type="text" placeholder="Search..."
                                            (input)="onManagerSearchInput($event)"
                                            class="dropdown-manager-search-input form-control dark:text-textDark dark:bg-[#292929] w-full p-2 pr-10 border-b border-gray-300 rounded-t-md" />
                                        <i
                                            class="fa-solid fa-magnifying-glass absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"></i>
                                    </div>
                                </div>

                                <!-- List -->
                                <div *ngFor="let item of filteredManagerArr"
                                    class="flex items-center p-2 hover:bg-gray-200 bg-white dark:hover:bg-gray-700 dark:bg-[#292929] dark:text-textDark cursor-pointer"
                                    (click)="selectManager(item)">
                                    <span [ngClass]="{
      'text-blue-600 dark:text-blue-400 font-medium': item.id === personalData.irmId,
      'text-gray-900 dark:text-textDark': item.id !== personalData.irmId
    }">

                                        {{ item.empId }} - {{ item.firstNameEnglish }} {{ item.lastNameEnglish }}

                                    </span>
                                    <span *ngIf="item.id === personalData.irmId" class="ml-2 text-blue-600">✓</span>
                                </div>
                                <div *ngIf="filteredManagerArr.length === 0"
                                    class="p-2 text-gray-500 dark:text-gray-400 bg-white dark:bg-[#292929] text-sm text-center">
                                    No options found
                                </div>
                            </div>
                        </div>

                        <div *ngIf="irmIdInput.touched && !personalData.irmId && logingRole === 'Distribution Centre Head'"
                            class="text-red-500 text-sm mt-1">
                            <div>Distribution Centre Manager is required</div>
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 mb-4">

                    <div>
                        <label for="languages" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Staff employee type *
                        </label>

                        <div class="flex items-center space-x-4 mt-3">
                            <div class="flex items-center space-x-2">
                                <input class="w-5 h-5 cursor-pointer" type="radio" id="sinhala" name="employeeType"
                                    value="Permanent" [(ngModel)]="personalData.employeeType"
                                    #employeeTypeInput="ngModel">
                                <label for="sinhala"
                                    class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Permanent</label>
                            </div>
                            <div class="flex items-center space-x-2">
                                <input class="w-5 h-5 cursor-pointer" type="radio" id="employeeType" name="employeeType"
                                    value="Temporary" [(ngModel)]="personalData.employeeType"
                                    #employeeTypeInput="ngModel">
                                <label for="english"
                                    class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Temporary</label>
                            </div>
                        </div>

                        <div *ngIf="employeeTypeInput.touched && !personalData.employeeType"
                            class="text-red-500 text-sm mt-1">
                            <div>Employee Type is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="languages" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Preferred Languages *
                        </label>

                        <div class="flex items-center space-x-4 mt-3">
                            <div class="flex items-center space-x-2">
                                <input class="w-5 h-5 cursor-pointer" type="checkbox" id="sinhala" name="languages"
                                    value="Sinhala" [checked]="personalData.languages.includes('Sinhala')"
                                    (change)="onCheckboxChange('Sinhala', $event)" />
                                <label for="sinhala" class="text-[#534E4E] mb-1 dark:text-textDark">Sinhala</label>
                            </div>
                            <div class="flex items-center space-x-2">
                                <input class="w-5 h-5 cursor-pointer" type="checkbox" id="english" name="languages"
                                    value="English" [checked]="personalData.languages.includes('English')"
                                    (change)="onCheckboxChange('English', $event)" />
                                <label for="english" class="text-[#534E4E] mb-1 dark:text-textDark">English</label>
                            </div>
                            <div class="flex items-center space-x-2">
                                <input class="w-5 h-5 cursor-pointer" type="checkbox" id="tamil" name="languages"
                                    value="Tamil" [checked]="personalData.languages.includes('Tamil')"
                                    (change)="onCheckboxChange('Tamil', $event)" />
                                <label for="tamil" class="text-[#534E4E] mb-1 dark:text-textDark">Tamil</label>
                            </div>
                        </div>

                        <p *ngIf="languagesRequired === true" class="text-red-500 text-sm mt-2">
                            Please select at least one Preferred Language.
                        </p>
                    </div>


                    <div>
                        <label for="firstNameEnglish"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">First
                            Name (in English) *</label>
                        <input id="firstNameEnglish" [(ngModel)]="personalData.firstNameEnglish" name="firstNameEnglish"
                            class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #firstNameEnglishInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'firstNameEnglish')" />
                        <div *ngIf="firstNameEnglishInput.touched && !personalData.firstNameEnglish"
                            class="text-red-500 text-sm mt-1">
                            <div>First Name (in English) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="lastNameEnglish"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Last
                            Name (in English) *</label>
                        <input id="lastNameEnglish" name="lastNameEnglish" [(ngModel)]="personalData.lastNameEnglish"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #lastNameEnglishInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'lastNameEnglish')" />
                        <div *ngIf="lastNameEnglishInput.touched && !personalData.lastNameEnglish"
                            class="text-red-500 text-sm mt-1">
                            <div>Last Name (in English) is required</div>
                        </div>
                    </div>

                    <div *ngIf="!isDriverRole(personalData.jobRole)">
                        <label for="firstNameSinhala"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">First
                            Name (in Sinhala) *</label>
                        <input id="firstNameSinhala" name="firstNameSinhala" [(ngModel)]="personalData.firstNameSinhala"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #firstNameSinhalaInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'firstNameSinhala')" />
                        <div *ngIf="firstNameSinhalaInput.touched && !personalData.firstNameSinhala"
                            class="text-red-500 text-sm mt-1">
                            <div>First Name (in Sinhala) is required</div>
                        </div>
                    </div>

                    <div *ngIf="!isDriverRole(personalData.jobRole)">
                        <label for="lastNameSinhala"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Last
                            Name (in Sinhala) *</label>
                        <input id="lastNameSinhala" name="lastNameSinhala" [(ngModel)]="personalData.lastNameSinhala"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #lastNameSinhalaInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'lastNameSinhala')" />
                        <div *ngIf="lastNameSinhalaInput.touched && !personalData.lastNameSinhala"
                            class="text-red-500 text-sm mt-1">
                            <div>Last Name (in Sinhala) is required</div>
                        </div>
                    </div>

                    <div *ngIf="!isDriverRole(personalData.jobRole)">
                        <label for="firstNameTamil"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">First
                            Name (in Tamil) *</label>
                        <input id="firstNameTamil" name="firstNameTamil" [(ngModel)]="personalData.firstNameTamil"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #firstNameTamilInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'firstNameTamil')" />
                        <div *ngIf="firstNameTamilInput.touched && !personalData.firstNameTamil"
                            class="text-red-500 text-sm mt-1">
                            <div>First Name (in Tamil) is required</div>
                        </div>
                    </div>

                    <div *ngIf="!isDriverRole(personalData.jobRole)">
                        <label for="lastNameTamil"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Last
                            Name (in Tamil) *</label>
                        <input id="lastNameTamil" name="lastNameTamil" [(ngModel)]="personalData.lastNameTamil"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #lastNameTamilInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'lastNameTamil')" />
                        <div *ngIf="lastNameTamilInput.touched && !personalData.lastNameTamil"
                            class="text-red-500 text-sm mt-1">
                            <div>Last Name (in Tamil) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="phoneNumber01"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Mobile Number - 1 *
                        </label>
                        <div class="mt-1 flex">
                            <!-- Country Code Dropdown -->
                            <div class="dropdown-wrapper-1 relative inline-block w-36 mr-2">
                                <!-- Selected item -->
                                <div class="flex items-center justify-between p-2 border border-gray-300 rounded-md bg-gray-50 dark:bg-[#1D1D1F] text-[#534E4E] dark:text-textDark cursor-pointer"
                                    (click)="dropdownOpen = !dropdownOpen">
                                    <div class="flex items-center gap-2">
                                        <img *ngIf="selectedCountry1" [src]="getFlagUrl(selectedCountry1.code)"
                                            width="24" height="18" alt="{{ selectedCountry1.name }}" />
                                        <span>{{ selectedCountry1?.dialCode }}</span>
                                    </div>
                                    <span *ngIf="!dropdownOpen"><i class="fa-solid fa-angle-down"></i></span>
                                    <span *ngIf="dropdownOpen"><i class="fa-solid fa-angle-up"></i></span>
                                </div>

                                <!-- Dropdown list -->
                                <div *ngIf="dropdownOpen"
                                    class="absolute left-0 mt-1 w-full border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] z-10 max-h-40 overflow-y-auto">
                                    <div *ngFor="let country of countries"
                                        class="flex items-center gap-2 p-2 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
                                        (click)="selectCountry1(country)">
                                        <img [src]="getFlagUrl(country.code)" width="24" height="18"
                                            alt="{{ country.name }}" />
                                        <span class="dark:text-white">{{ country.dialCode }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Phone Number Input with Validation -->
                            <input id="phoneNumber01" name="phoneNumber01" type="tel"
                                [(ngModel)]="personalData.phoneNumber01" #phoneNumber01Input="ngModel"
                                class="block w-full p-2 border border-gray-300 rounded-r-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                                placeholder="Enter your mobile number" required pattern="^[0-9]{9}$" minlength="9"
                                (ngModelChange)="validateSriLankanPhone($event, 'phone01')"
                                (keypress)="blockInvalidKeypressForPhone($event)" (input)="onPhoneInput($event)"
                                (paste)="blockInvalidPasteForPhone($event)" maxlength="9"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                        </div>

                        <!-- Validation Messages -->
                        <div *ngIf="phoneNumber01Input.touched">
                            <div *ngIf="!personalData.phoneNumber01" class="text-red-500 text-sm mt-1">
                                Mobile Number - 1 is required.
                            </div>
                            <div *ngIf="personalData.phoneNumber01 && phoneNumber01Input.invalid && !isPhoneInvalidMap['phone01']"
                                class="text-red-500 text-sm mt-1">
                                Mobile Number must be exactly 9 digits.
                            </div>
                        </div>
                    </div>

                    <div>
                        <label for="phoNumTwo" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Mobile Number - 2
                        </label>
                        <div class="mt-1 flex">
                            <div class="dropdown-wrapper-2 relative inline-block w-36 mr-2">
                                <!-- Selected item -->
                                <div class="flex items-center justify-between p-2 border border-gray-300 rounded-md bg-gray-50 dark:bg-[#1D1D1F] text-[#534E4E] dark:text-textDark cursor-pointer"
                                    (click)="dropdownOpen2 = !dropdownOpen2">
                                    <div class="flex items-center gap-2">
                                        <img *ngIf="selectedCountry2" [src]="getFlagUrl(selectedCountry2.code)"
                                            width="24" height="18" alt="{{ selectedCountry2.name }}" />
                                        <span>{{ selectedCountry2?.dialCode }}</span>
                                    </div>
                                    <span *ngIf="!dropdownOpen2"><i class="fa-solid fa-angle-down"></i></span>
                                    <span *ngIf="dropdownOpen2"><i class="fa-solid fa-angle-up"></i></span>
                                </div>

                                <!-- Dropdown list -->
                                <div *ngIf="dropdownOpen2"
                                    class="absolute left-0 mt-1 w-full border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] z-10 max-h-40 overflow-y-auto">
                                    <div *ngFor="let country of countries"
                                        class="flex items-center gap-2 p-2 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
                                        (click)="selectCountry2(country)">
                                        <img [src]="getFlagUrl(country.code)" width="24" height="18"
                                            alt="{{ country.name }}" />
                                        <span class="dark:text-white">{{ country.dialCode }}</span>
                                    </div>
                                </div>
                            </div>
                            <input id="phoneNumber02" name="phoneNumber02" type="tel"
                                [(ngModel)]="personalData.phoneNumber02" #phoneNumber02Input="ngModel"
                                class="block w-full p-2 border border-gray-300 rounded-r-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                                placeholder="Enter your mobile number" pattern="^[0-9]{9}$" minlength="9" maxlength="9"
                                (ngModelChange)="validateSriLankanPhone($event, 'phone02')"
                                (keypress)="blockInvalidKeypressForPhone($event)" (input)="onPhoneInput($event)"
                                (paste)="blockInvalidPasteForPhone($event)"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />
                        </div>

                        <!-- Custom Validation: Same as Phone Number 1 -->
                        <div *ngIf="personalData.phoneNumber02 && personalData.phoneNumber02 === personalData.phoneNumber01 && !isPhoneInvalidMap['phone02'] && !phoneNumber02Input.invalid"
                            class="text-red-500 text-sm mt-1">
                            Mobile Number - 2 should be different from Mobile Number - 1.
                        </div>

                        <div *ngIf="personalData.phoneNumber02 && phoneNumber02Input.invalid && !isPhoneInvalidMap['phone02']"
                            class="text-red-500 text-sm mt-1">
                            Mobile Number must be exactly 9 digits.
                        </div>
                    </div>

                    <div>
                        <label for="nic" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">NIC
                            Number *</label>
                        <input id="nic" name="nic" [(ngModel)]="personalData.nic"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #nicInput="ngModel" required maxlength="12" pattern="^(\d{9}[V]|\d{12})$"
                            (input)="onNicInput($event)"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
                        <div *ngIf="nicInput.touched && !personalData.nic" class="text-red-500 text-sm mt-1">
                            <div> NIC is required</div>
                        </div>
                        <div *ngIf="nicInput.touched && nicInput.errors?.['pattern']" class="text-red-500 text-sm mt-1">
                            <div>Please enter a valid NIC number (12 digits or 10 digits followed by 'V').</div>
                        </div>
                    </div>

                    <div>
                        <label for="email"
                            class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Email *</label>
                        <input type="email" id="email" name="email" [(ngModel)]="personalData.email"
                            class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #emailInput="ngModel" required
                            pattern="^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$"
                            (input)="onTrimInput($event, personalData, 'email')" />
                        <div *ngIf="emailInput.touched && !personalData.email" class="text-red-500 text-sm mt-1">
                            Email is required
                        </div>

                        <div *ngIf="emailInput.touched && emailInput.errors?.['pattern']"
                            class="text-red-500 text-sm mt-1">
                            <p>Please enter a valid email in the format: example&#64;domain.com</p>
                        </div>
                    </div>
                </div>

                <div class="flex justify-end my-10 ml-10">
                    <button type="button"
                        class="px-6 py-2 bg-[#F6F7F9] border-gray-400 border-[2px] text-[#6B7D8C] rounded-lg mr-2"
                        (click)="onCancel()">Cancel</button>
                    <button (click)="
      !PageOneForm.invalid
      && this.languagesRequired === false
      && personalData.phoneNumber02 !== personalData.phoneNumber01 
      && personalData.jobRole 
      && (!isDriverRole(personalData.jobRole) || personalData.drvCategory)
      && !isPhoneInvalidMap['phone01'] 
      && ((personalData.phoneNumber02 && !isPhoneInvalidMap['phone02']) || !personalData.phoneNumber02)
        ? nextForm('pageTwo') 
        : nextForm('pageOne')
    " type="submit" class="px-6 py-1 bg-[#415CFF] text-white rounded-lg">
                        Next
                    </button>
                </div>

            </div>
        </div>
    </form>

    <form #PageTwoForm="ngForm" (ngSubmit)="onSubmitFormPage2(PageTwoForm)">

        <div *ngIf="selectedPage === 'pageTwo'">
            <h2 class="text-xl mb-6 text-[#292929] dark:text-textDark">Residential Details</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">

                <div>
                    <label for="house" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">House /
                        Plot Number *</label>
                    <input id="houseNumber" name="houseNumber" [(ngModel)]="personalData.houseNumber"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #houseNumberInput="ngModel" required
                        (input)="onFormatInput2($event, personalData, 'houseNumber')" />
                    <div *ngIf="houseNumberInput.touched && !personalData.houseNumber"
                        class="text-red-500 text-sm mt-1">
                        <div>House / Plot Number is required</div>
                    </div>
                </div>

                <div>
                    <label for="street" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Street
                        Name *</label>
                    <input id="streetName" name="streetName" [(ngModel)]="personalData.streetName"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #streetNameInput="ngModel" required
                        (input)="onFormatInput2($event, personalData, 'streetName')" />
                    <div *ngIf="streetNameInput.touched && !personalData.streetName" class="text-red-500 text-sm mt-1">
                        <div>Street Name is required</div>
                    </div>
                </div>

                <div>
                    <label for="city" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">City
                        *</label>
                    <input id="city" name="city" [(ngModel)]="personalData.city"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #cityInput="ngModel" required (input)="onFormatInput2($event, personalData, 'city')" />
                    <div *ngIf="cityInput.touched && !personalData.city" class="text-red-500 text-sm mt-1">
                        <div>City is required</div>
                    </div>
                </div>

                <div>
                    <label for="district" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                        District *
                    </label>

                    <app-searchable-dropdown id="district" name="district" [items]="districtItems"
                        [placeholder]="'Select a district'" [searchPlaceholder]="'Search districts...'"
                        [(ngModel)]="personalData.district" #districtInput="ngModel"
                        (ngModelChange)="onDistrictChange($event)" borderClass="border border-gray-300"
                        placeholderClass="text-gray-400"></app-searchable-dropdown>

                    <!-- validation message (same logic you already use) -->
                    <div *ngIf="districtInput.touched && !personalData.district" class="text-red-500 text-sm mt-1">
                        <div>District is required</div>
                    </div>
                </div>

                <div>
                    <label for="province" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                        Province *
                    </label>
                    <input id="province" name="province" [(ngModel)]="personalData.province" #provinceInput="ngModel"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        readonly />

                    <div *ngIf="provinceInput.touched && !personalData.province" class="text-red-500 text-sm mt-1">
                        <div>Province is required</div>
                    </div>
                </div>

                <div>
                    <label for="country"
                        class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Country *</label>
                    <input readonly id="country" name="country" [(ngModel)]="personalData.country"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
                </div>
            </div>
            <div>
                <h2 class="text-xl mt-10 mb-6 text-[#292929] dark:text-textDark">Edit Bank Details</h2>
                <div class="pb-6">
                    <label for="accHolderName"
                        class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Account
                        Holder’s Name *</label>
                    <input id="accHolderName" name="accHolderName" [(ngModel)]="personalData.accHolderName"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #accHolderNameInput="ngModel" required maxlength="50" pattern="^[a-zA-Z0-9\s.']*$"
                        (keydown)="blockSpecialChars($event)"
                        (input)="onFormatInput($event, personalData, 'accHolderName')" />
                    <div *ngIf="accHolderNameInput.touched && !personalData.accHolderName"
                        class="text-red-500 text-sm mt-1">
                        <div>Account Holder's Name is required</div>
                    </div>
                    <div *ngIf="accHolderNameInput.touched && personalData.accHolderName && accHolderNameInput.invalid"
                        class="text-red-500 text-sm mt-1">
                        Please do not enter any special characters(eg., !, $, etc).
                    </div>
                </div>

                <div class="pb-6">
                    <label for="accNumber"
                        class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Account
                        Number *</label>
                    <input type="text" inputmode="numeric" id="accNumber" name="accNumber"
                        [(ngModel)]="personalData.accNumber"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #accNumberInput="ngModel" required pattern="^[0-9]+$" (keydown)="blockNonNumbers($event)"
                        (input)="onTrimInputAccountNumber($event, personalData, 'accNumber')" />
                    <div *ngIf="accNumberInput.touched && !personalData.accNumber" class="text-red-500 text-sm mt-1">
                        <div>Account Number is required</div>
                    </div>
                    <div *ngIf="accNumberInput.touched && personalData.accNumber && accNumberInput.errors?.['pattern']"
                        class="text-red-500 text-sm mt-1">
                        <div>Account Number should only contain numbers</div>
                    </div>
                </div>

                <div class="pb-6">
                    <label for="conformAccNumber"
                        class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">Confirm Account
                        Number *</label>
                    <input type="text" inputmode="numeric" id="conformAccNumber" name="conformAccNumber"
                        [(ngModel)]="personalData.conformAccNumber"
                        class="mt-1 block w-full p-2 border border-gray-300 rounded-md text-[#292929] dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #confirmAccNumberInput="ngModel" required pattern="^[0-9]+$" (keydown)="blockNonNumbers($event)"
                        (input)="onTrimInputAccountNumber($event, personalData, 'conformAccNumber')" />
                    <div *ngIf="confirmAccNumberInput.touched && !personalData.conformAccNumber"
                        class="text-red-500 text-sm mt-1">
                        <div>Confirm Account Number is required</div>
                    </div>
                    <div *ngIf="personalData.conformAccNumber && (personalData.accNumber !== personalData.conformAccNumber) && !confirmAccNumberInput.errors?.['pattern']"
                        class="text-red-500 text-sm mt-1">
                        <div>Confirm Account Number should be the same as Account Number.</div>
                    </div>
                    <div *ngIf="confirmAccNumberInput.touched && personalData.conformAccNumber && confirmAccNumberInput.errors?.['pattern']"
                        class="text-red-500 text-sm mt-1">
                        <div>Confirm Account Number should only contain numbers</div>
                    </div>
                </div>

                <div class="pb-6">
                    <label for="bankDropdown" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                        Bank Name *
                    </label>
                    <app-searchable-dropdown [items]="bankItems" placeholder="Select a bank"
                        searchPlaceholder="Search banks..." [(ngModel)]="selectedBankId" name="bankDropdown"
                        #selectedBank="ngModel" (selectionChange)="onBankChange($event)" [clearable]="true"
                        borderClass="border border-gray-300" placeholderClass="text-gray-400">
                    </app-searchable-dropdown>

                    <div *ngIf="!selectedBankId && selectedBank.touched" class="text-red-500 text-sm mt-1">
                        <div>Please select a bank</div>
                    </div>
                </div>

                <div class="pb-6">
                    <label for="branchDropdown"
                        class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                        Branch Name *
                    </label>
                    <app-searchable-dropdown [items]="branchItems" placeholder="Select a branch"
                        searchPlaceholder="Search branches..." [(ngModel)]="selectedBranchId" name="branchDropdown"
                        #selectedBranch="ngModel" (selectionChange)="onBranchChange($event)"
                        [disabled]="!selectedBankId" [clearable]="true" borderClass="border border-gray-300"
                        placeholderClass="text-gray-400">
                    </app-searchable-dropdown>

                    <div *ngIf="!selectedBranchId && selectedBranch.touched" class="text-red-500 text-sm mt-1">
                        <div>Please select a branch</div>
                    </div>
                </div>
            </div>

            <div class="flex justify-end my-10 ml-10">
                <button (click)="nextForm('pageOne')" type="button"
                    class="px-8 py-2 bg-[#F6F7F9] border-gray-400 border-[2px] text-[#6B7D8C] rounded-lg mr-2">Back</button>

                <button *ngIf="!isDriverRole(personalData.jobRole)" type="submit"
                    class="px-6 py-1 bg-[#415CFF] text-[#FFFFFF] rounded-lg" (click)="
                    !PageTwoForm.invalid 
                      ? onSubmit()
                      : nextForm('pageTwo')
                  ">
                    Sent to Approve
                </button>


                <button *ngIf="isDriverRole(personalData.jobRole)" type="submit"
                    class="px-6 py-1 bg-[#415CFF] text-[#FFFFFF] rounded-lg" (click)="
                    !PageTwoForm.invalid && selectedBankId && selectedBranchId && (personalData.accNumber === personalData.conformAccNumber)
                      ? nextForm('pageThree')
                      : nextForm('pageTwo')
                  ">
                    Next
                </button>

            </div>
        </div>
    </form>

    <form #PageThreeForm="ngForm" (ngSubmit)="onSubmitFormPage3(PageThreeForm)">

        <div *ngIf="selectedPage === 'pageThree'">

            <h2 class="text-xl mb-6 text-textLight dark:text-textDark font-bold">Driving Details</h2>


            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-11 my-5">

                <div>
                    <label for="licNo" class="block text-sm font-medium text-gray-700 dark:text-textDark">
                        Driving License ID *
                    </label>
                    <input id="licNo" #licNoInput="ngModel" type="text" name="licNo" [(ngModel)]="driverObj.licNo"
                        pattern="^([A-Z]\d{7}|\d{10,12})$" (keypress)="preventSpecialCharacters($event)"
                        (paste)="preventSpecialCharactersPaste($event)"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />

                    <div>
                        <span class="text-red-500 text-sm"
                            *ngIf="licNoInput.touched && licNoInput.errors?.['pattern'] && driverObj.licNo">
                            Please enter a valid License ID number (1 capital letter + 7 digits or 10–12 digits).
                        </span>

                        <span class="text-red-500 text-sm" *ngIf="licNoInput.touched && !driverObj.licNo">
                            Driving License ID number is Required.
                        </span>
                    </div>
                </div>

                <div>
                    <label for="confirmLicNo" class="block text-sm font-medium text-gray-700 dark:text-textDark">
                        Confirm Driving License ID *
                    </label>
                    <input id="confirmLicNo" #confirmLicNoInput="ngModel" type="text" name="confirmLicNo"
                        [(ngModel)]="driverObj.confirmLicNo" (keypress)="preventSpecialCharacters($event)"
                        (paste)="preventSpecialCharactersPaste($event)"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />

                    <div>
                        <span class="text-red-500 text-sm"
                            *ngIf="confirmLicNoInput.touched && (driverObj.licNo !== driverObj.confirmLicNo) && driverObj.confirmLicNo">
                            Confirm Driving License ID number should match the Driving License ID number.
                        </span>

                        <span class="text-red-500 text-sm" *ngIf="confirmLicNoInput.touched && !driverObj.confirmLicNo">
                            Confirm Driving License ID number is Required.
                        </span>
                    </div>

                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="licenseFrontImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">
                            License's Front Image
                        </label>
                        <a [href]="driverObj.licFrontImg" target="_blank">
                            <i *ngIf="driverObj.licFrontImg" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>

                    <input id="licenseFrontImageUpload" type="file" accept="image/*"
                        (change)="onLicenseFrontImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'licenseFrontImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload License Front Image</p>
                    </div>

                    <div *ngIf="licenseFrontImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                licenseFrontImageFileName }}</span></span>
                        <button (click)="clearLicenseFrontImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="licenseBackImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">License’s Back
                            Image</label>
                        <a [href]="driverObj.licBackImg" target="_blank">
                            <i *ngIf="driverObj.licBackImg" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>


                    <input id="licenseBackImageUpload" type="file" accept="image/*"
                        (change)="onLicenseBackImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'licenseBackImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Back Image</p>
                    </div>
                    <div *ngIf="licenseBackImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                licenseBackImageFileName }}</span></span>
                        <button (click)="clearLicenseBackImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>

            <h2 class="text-xl mt-16 mb-6 text-textLight dark:text-textDark font-bold">Vehicle Insurance Details</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-11 my-5">
                <div>
                    <label for="insNo" class="block text-sm font-medium text-gray-700 dark:text-textDark">
                        Insurance Number *
                    </label>
                    <input id="insNo" type="text" maxlength="13" (keypress)="preventSpaces($event)"
                        (input)="removeSpaces($event, driverObj, 'insNo')" #insurenceNoInput="ngModel" name="insNo" [(ngModel)]="driverObj.insNo"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
                    <div>
                        <span class="text-red-500 text-sm" *ngIf="insurenceNoInput.touched && !driverObj.insNo">
                            Insurance Number Required.
                        </span>
                    </div>
                </div>

                <div>
                    <label for="insNo" class="block text-sm font-medium text-gray-700 dark:text-textDark">
                        Confirm Insurance Number *
                    </label>
                    <input id="insNo" type="text" maxlength="13" #confirmInsurenceNoInput="ngModel" name="insNo"
                        [(ngModel)]="driverObj.confirmInsNo" (keypress)="preventSpaces($event)"
                        (input)="removeSpaces($event, driverObj, 'confirmInsNo')"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />

                    <div>
                        <span class="text-red-500 text-sm"
                            *ngIf="confirmInsurenceNoInput.touched && (driverObj.insNo !== driverObj.confirmInsNo) && driverObj.confirmInsNo">
                            Confirm Insurance Number should match the Insurance Number.
                        </span>

                        <span class="text-red-500 text-sm"
                            *ngIf="confirmInsurenceNoInput.touched && !driverObj.confirmInsNo">
                            Confirm Insurance Number is Required.
                        </span>
                    </div>
                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="insurenceFrontImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Insurance’s Front
                            Image</label>
                        <a [href]="driverObj.insFrontImg" target="_blank">
                            <i *ngIf="driverObj.insFrontImg" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>

                    <input id="insurenceFrontImageUpload" type="file" accept="image/*"
                        (change)="onInsurenceFrontImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'insurenceFrontImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Front Image</p>
                    </div>
                    <div *ngIf="insurenceFrontImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                insurenceFrontImageFileName }}</span></span>
                        <button (click)="clearInsurenceFrontImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="insuranceBackImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Insurance’s Back
                            Image</label>
                        <a [href]="driverObj.insBackImg" target="_blank">
                            <i *ngIf="driverObj.insBackImg" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>

                    <input id="insuranceBackImageUpload" type="file" accept="image/*"
                        (change)="onInsurenceBackImageSelected($event)" class="hidden">
                    <div (click)="triggerFileInputForDriver($event, 'insuranceBackImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Back Image</p>
                    </div>
                    <div *ngIf="insurenceBackImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                insurenceBackImageFileName }}</span></span>
                        <button (click)="clearInsurenceBackImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div>
                    <label for="insExpDate"
                        class="block text-sm mb-1 font-medium text-[#534E4E] dark:text-textDark">Insurance
                        Expire Date</label>
                    <app-custom-datepicker name="insExpDate" [minDate]="today" [(selectedDate)]="driverObj.insExpDate"
                        placeholder="mm/dd/yyyy" (dateChange)="onInsuranceDateChange($event)"
                        triggerClass="w-full h-12 border-[1.8px] border-gray-300 rounded-xl flex items-center px-3 py-2 cursor-pointer dark:bg-[#292929]"
                        (pickerOpened)="onDatePickerClicked()"></app-custom-datepicker>

                    <div *ngIf="insExpDateTouched && !driverObj.insExpDate" class="text-red-500 text-sm mt-1">
                        Insurance Expire Date is required
                    </div>
                </div>
            </div>


            <h2 class="text-xl mt-16 mb-6 text-textLight dark:text-textDark font-bold">Vehicle Details</h2>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-11 my-5">
                <div class="mt-2">
                    <label for="vRegNo" class="block text-sm font-medium text-gray-700 dark:text-textDark">
                        Vehicle Registration Number *
                    </label>
                    <input id="vRegNo" type="text" #vRegNoInput="ngModel" name="vRegNo" [(ngModel)]="driverObj.vRegNo"
                        (keypress)="preventSpecialCharacters($event)" (paste)="preventSpecialCharactersPaste($event)"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />

                    <div>
                        <span class="text-red-500 text-sm" *ngIf="vRegNoInput.touched && !driverObj.vRegNo">
                            Vehicle Registration Number is Required.
                        </span>
                    </div>
                </div>

                <div class="mt-2">
                    <label for="confirmVRegNo" class="block text-sm font-medium text-gray-700 dark:text-textDark">
                        Confirm Vehicle Registration Number *
                    </label>
                    <input id="confirmVRegNo" type="text" #confirmVRegNoInput="ngModel" name="confirmVRegNo"
                        [(ngModel)]="driverObj.confirmVRegNo" (keypress)="preventSpecialCharacters($event)"
                        (paste)="preventSpecialCharactersPaste($event)"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
                    <div>
                        <span class="text-red-500 text-sm"
                            *ngIf="confirmVRegNoInput.touched && (driverObj.vRegNo !== driverObj.confirmVRegNo) && driverObj.confirmVRegNo">
                            Confirm Vehicle Registration Number should match the Vehicle Registration Number.
                        </span>
                        <span class="text-red-500 text-sm"
                            *ngIf="confirmVRegNoInput.touched && !driverObj.confirmVRegNo">
                            Confirm Vehicle Registration Number is Required.
                        </span>
                    </div>
                </div>

                <div>
                    <label for="selectVehicletype"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Vehicle Type</label>
                    <div class="relative w-full">
                        <div class="relative">
                            <input type="text" id="selectVehicletype" [value]="selectVehicletype?.name || ''"
                                placeholder="-- Select a Vehicle Type --" readonly (click)="toggleVehicleTypeDropdown()"
                                class="form-control mt-1 block w-full p-2 pr-10 border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] text-gray-700 dark:text-textDark cursor-pointer hover:bg-gray-200" />
                            <i *ngIf="!vehicleTypeDropdownOpen"
                                class="fa-solid fa-angle-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                            <i *ngIf="vehicleTypeDropdownOpen"
                                class="fa-solid fa-angle-up absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                        </div>
                        <div *ngIf="vehicleTypeDropdownOpen"
                            class="absolute z-50 mt-1 w-full bg-white dark:bg-[#292929] border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
                            <div *ngFor="let item of VehicleTypes" (click)="selectVehicleTypeItem(item)"
                                class="flex items-center p-2 text-gray-700 dark:text-textDark cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700">
                                <span [ngClass]="{
          'text-blue-600 dark:text-blue-400 font-medium': item.name === selectVehicletype?.name,
          'text-blue-600 dark:text-blue-400': item.name === selectVehicletype?.name
        }">

                                    {{ item.name }}

                                </span>
                                <span *ngIf="item.name === selectVehicletype?.name" class="ml-2 text-blue-600">✓</span>



                            </div>
                        </div>
                    </div>
                    <div *ngIf="vehicleTypeTouched && !driverObj.vType" class="text-red-500 text-sm mt-1">
                        <div>Vehicle Type is required</div>
                    </div>
                </div>

                <div>
                    <label for="capacity" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Vehicle
                        Capacity</label>
                    <input id="capacity" placeholder="------------" [value]="selectVehicletype?.capacity"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        readonly />

                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="vehicleFrontImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Front
                            Image</label>
                        <a [href]="driverObj.vehFrontImg" target="_blank">
                            <i *ngIf="driverObj.vehFrontImg" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>

                    <input id="vehicleFrontImageUpload" type="file" accept="image/*"
                        (change)="onVehicleFrontImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleFrontImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Front Image</p>
                    </div>
                    <div *ngIf="vehicleFrontImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleFrontImageFileName }}</span></span>
                        <button (click)="clearVehicleFrontImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="vehicleBackImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Back
                            Image</label>
                        <a [href]="driverObj.vehBackImg" target="_blank">
                            <i *ngIf="driverObj.vehBackImg" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>

                    <input id="vehicleBackImageUpload" type="file" accept="image/*"
                        (change)="onVehicleBackImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleBackImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Back Image</p>
                    </div>
                    <div *ngIf="vehicleBackImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleBackImageFileName }}</span></span>
                        <button (click)="clearVehicleBackImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="vehicleSideAImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Side
                            Image -
                            1</label>
                        <a [href]="driverObj.vehSideImgA" target="_blank">
                            <i *ngIf="driverObj.vehSideImgA" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>

                    <input id="vehicleSideAImageUpload" type="file" accept="image/*"
                        (change)="onVehicleSideAImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleSideAImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Side Image - 1</p>
                    </div>
                    <div *ngIf="vehicleSideAImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleSideAImageFileName }}</span></span>
                        <button (click)="clearVehicleSideAImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>

                <div>
                    <div class="flex flex-row items-center gap-4">
                        <label for="vehicleSideBImageUpload"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Side
                            Image -
                            2</label>
                        <a [href]="driverObj.vehSideImgB" target="_blank">
                            <i *ngIf="driverObj.vehSideImgB" class="fa-solid fa-eye text-lg text-[#415CFF]"></i>
                        </a>
                    </div>

                    <input id="vehicleSideBImageUpload" type="file" accept="image/*"
                        (change)="onVehicleSideBImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleSideBImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Side Image - 2</p>
                    </div>
                    <div *ngIf="vehicleSideBImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleSideBImageFileName }}</span></span>
                        <button (click)="clearVehicleSideBImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>



            <div class="flex justify-end mt-10">
                <button (click)="nextForm('pageTwo')" type="button"
                    class="px-6 py-2 bg-[#F6F7F9] border-gray-400 border-[2px] text-[#6B7D8C] rounded-lg mr-2">Back</button>
                <button type="submit" class="px-6 py-1 bg-[#415CFF] text-white rounded-lg">Sent to
                    Approve</button>
            </div>
        </div>
    </form>


</div>